import React from 'react';
import { Typography, Box, Paper, Chip } from '@material-ui/core';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import NewReleasesRoundedIcon from '@material-ui/icons/NewReleasesRounded';
import ReleaseCard from './ReleaseCard';

const ReleaseTimeline = ({ filteredUpdates, sortedUpdatesLength, latestUpdate, hasLoadError, isLoading, selectedApplication, selectedApplicationArtwork, getReleaseAccent, getReleaseArtwork, getReleaseStatus, getReleaseEnhancement }) => {
    return (
        <>
            <Box id="release-highlights" className="whats-new-section-head">
                <NewReleasesRoundedIcon />
                <Typography className="whats-new-section-title">Release Highlights</Typography>
                {selectedApplication ? (
                    <Box className="whats-new-section-application">
                        {selectedApplicationArtwork?.src ? (
                            <Box component="img" src={selectedApplicationArtwork.src} alt="" className="whats-new-section-application-logo" />
                        ) : null}
                        <Typography>{selectedApplication.label}</Typography>
                    </Box>
                ) : null}
                <Chip label={`${filteredUpdates.length} ${filteredUpdates.length === 1 ? 'story' : 'stories'}`} size="small" className="whats-new-section-count" />
            </Box>
            {filteredUpdates.length > 0 ? (
                <Box className="whats-new-timeline">
                    {filteredUpdates.map((item, index) => (
                        <ReleaseCard
                            key={item?.slug || item?.id || index}
                            item={item}
                            accent={getReleaseAccent(item)}
                            artwork={selectedApplication ? null : getReleaseArtwork(item)}
                            isLatestRelease={item === latestUpdate}
                            releaseEnhancement={getReleaseEnhancement(item)}
                            releaseStatus={getReleaseStatus(item)}
                        />
                    ))}
                </Box>
            ) : !isLoading ? (
                <Paper elevation={0} className="whats-new-empty-state">
                    <SearchRoundedIcon />
                    <Typography className="whats-new-empty-title">
                        {hasLoadError ? 'Updates are temporarily unavailable' : sortedUpdatesLength === 0 ? 'No releases have been published yet' : 'No release updates match your selection'}
                    </Typography>
                    <Typography className="whats-new-empty-subtitle">
                        {hasLoadError ? 'Please refresh the page or try again shortly.' : sortedUpdatesLength === 0 ? 'New product announcements will appear here when they are ready.' : 'Adjust your search terms or choose a different SPARTA product to view available updates.'}
                    </Typography>
                </Paper>
            ) : null}
        </>
    )
};

export default ReleaseTimeline;